<template>
  <div>
    <slot name="activator" :attrs="bindAttrs" :open="isOpen">
      <button
        v-bind="bindAttrs"
        :aria-expanded="isOpen"
        :aria-controls="id"
        class="flex w-full items-center justify-between text-sm font-semibold uppercase text-text-secondary"
      >
        <span>{{ title }}</span>
        <UiIcon
          :name="isOpen ? 'expand_less' : 'expand_more'"
          class="pointer-events-none h-5 w-5 flex-shrink-0 text-primary"
        />
      </button>
    </slot>
    <LazySharedCollapseTransition>
      <div v-if="isOpen" :id="id" :class="cn('mt-6', contentClasses)">
        <slot name="content" />
      </div>
    </LazySharedCollapseTransition>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue?: any;
  open?: boolean;
  title?: string;
  contentClasses?: string;
}>();

const id = useId();
const isOpen = defineModel<boolean>();

isOpen.value = props.modelValue;

function toggle() {
  isOpen.value = !isOpen.value;
}

const bindAttrs = {
  onClick: toggle,
  open: props.open,
  ariaExpanded: isOpen.value,
  ariaControls: id,
};
</script>
